import React, { useState, useRef } from 'react';
import { Box, Text, Flex, Input, VStack, Checkbox, Link, Button } from '@chakra-ui/react'
import { ExternalLinkIcon } from '@chakra-ui/icons'
import wisdom from "./assets/wisdom.svg";

import styled from "@emotion/styled";
import {
  AutoComplete,
  AutoCompleteInput,
  AutoCompleteItem,
  AutoCompleteList,
} from "@choc-ui/chakra-autocomplete";

//import LANGS from "./languages";
import { codes } from "./languages";

const StyledImg = styled.img`
height:40px;
width:220px;
cursor:pointer;
`;

const StyledInput = styled(Input)`
background-color:white;
`;

const StyledBox = styled(Box)`
width:100%;
background:#2C5282;
padding:5px;
height:100vh;
@media screen and (max-height: 700px) {
min-height: 100vh;
min-height: fill-available;
min-height: -webkit-fill-available;
height: fill-available;
height: -webkit-fill-available;
}
`;


//@media screen and (max-width: 600px) {

const Welcome = ({ txts, currentLng, changeLng, init }) => {

  console.log("TEXTS ", txts);
  //const terms="The Wisdom AI demo is a simulation that demonstrates the capabilities that can be achieved by establishing and maintaining a centralized data repository (known as EOS) for ecosystem information and connecting it with the Wisdom AI App. This demo allows you to interact with ecosystem information in a conversational format that's easy to use and understand. During the demo, we record each chat session and related details to improve our services. By using this demo, you acknowledge and agree that we may record and store the session and related information. Any information you provide or prompts you enter will be sent to and processed by Digiole. We want to assure you that any personal information collected during this demo will be kept confidential and will not be disclosed to any third party without your consent, unless required by law. If you have any concerns about the collection, use, or storage of your personal information, please do not use this demo service. If you have any questions or comments, please feel free to contact us. Thank you for using our Wisdom AI demo service.";
  const inputRefs = {};
  const [termsChecked, setTermsChecked] = useState(false);

  //const lngOptions = Object.keys(LANGS);
  const defaultLng = useRef("");
  const countries = useRef(codes.map(lng => {
    //console.log(lng);
    const regName = new Intl.DisplayNames([lng], { type: 'language' });
    //console.log(lng, "=>", regName.of(lng))
    if (lng === currentLng) {
      defaultLng.current = regName.of(lng) + " [" + lng + "]"
    }
    return { code: lng, name: regName.of(lng) + " [" + lng + "]" }
    //console.log(regName.of(lng));
  }));

  //<div dangerouslySetInnerHTML={{ __html: "<h1>Hi there!</h1>" }} />
  //h={"100vh"} w={"100%"} bg={"#2C5282"} p={"5px"}
  return <>
    <StyledBox >
      <Box textAlign={"center"}>
        <Flex alignItems={"center"} justifyContent={"center"} pt={"40px"}>
          <StyledImg src={wisdom} onClick={() => {
            window.open(process.env.REACT_APP_PRIFINA_WISDOM_LOGO, '_blank');
          }} />
        </Flex>
        <Text pt={"120px"} color={"#EDF2F7"} fontWeight={"400"} fontSize={"32px"} lineHeight={"37px"} ><span dangerouslySetInnerHTML={{ __html: `${txts.welcome}` }} /></Text>
        <Text pt={"32px"} color={"#EDF2F7"} fontWeight={"400"} fontSize={"24px"} lineHeight={"28px"}>{txts.fillPrompt}</Text>

        <Flex pt={"64px"} justifyContent={"center"}>
          <Box style={{ maxWidth: "400px" }} width={["90%", "90%", "80%"]}>
            <VStack spacing='24px'>
              <AutoComplete openOnFocus defaultValues={[defaultLng.current]} onChange={(e, vals) => {
                //console.log("CHANGE ", e);
                //console.log("CHANGE ", vals);
                const regex = "\\[(.*?)\\]";
                const lngCode = vals.value
                console.log(lngCode)
                const matches = [...lngCode.matchAll(regex)];
                //console.log(matches)
                changeLng(matches[0][1]);
              }}>
                <AutoCompleteInput variant="filled" />
                <AutoCompleteList>
                  {countries.current.map((country, cid) => (
                    <AutoCompleteItem
                      key={`option-${cid}`}
                      value={country.name}
                      data-code={country.code}
                    >
                      {country.name}
                    </AutoCompleteItem>
                  ))}
                </AutoCompleteList>
              </AutoComplete>
              <StyledInput ref={(ref) => {
                if (ref) {
                  inputRefs["name"] = ref;
                }
              }} placeholder={txts.yourName} defaultValue={""} />
              <StyledInput ref={(ref) => {
                if (ref) {
                  inputRefs["email"] = ref;
                }
              }} placeholder={txts.emailAddress} defaultValue={""} />
              <StyledInput ref={(ref) => {
                if (ref) {
                  inputRefs["location"] = ref;
                }
              }} placeholder={txts.location} defaultValue={""} />


              <Box w={"100%"} textAlign={"left"}>
                <Checkbox ref={(ref) => {
                  if (ref) {
                    inputRefs["terms"] = ref;
                  }
                }} colorScheme='green' onChange={(e) => {
                  setTermsChecked(prev => !prev);
                }} >
                  <Text color={"white"}>
                    {txts.agree}
                  </Text>
                </Checkbox>
                <Link color={"yellow"} pl={"5px"} href={process.env.REACT_APP_PRIFINA_WISDOM_TERMS} isExternal>
                  {txts.terms}
                  <ExternalLinkIcon mx='2px' />
                </Link>
              </Box>
              <Button isDisabled={!termsChecked} colorScheme={"whatsapp"} onClick={(e) => {
                init(inputRefs);
              }}>{txts.start}</Button>
            </VStack>
          </Box>
        </Flex>
      </Box>
    </StyledBox>

  </>
}

export default Welcome;